export default __webpack_public_path__ + "static/media/pdvs-conquistar.931d62d1.svg";